import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-ability',
  template: ``,
  styleUrls: []
})
export class FormAbilityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
